import dotProp from 'dot-prop-immutable'

import actionCableConstants from '../../../ActionCable/constants'
import projectImportsConstants from './constants'

const initialState = {
  fetchingAllError: null,
  fetchingAllStatus: 'idle',

  items: null,

  itemsCount: null,
  itemsCurrentPage: null,
  itemsTotalPages: null
}

const insertOrUpdate = (state, projectImport) => {
  if (!state.items) return state

  const itemIndex = state.items.findIndex(
    (item) => item.id === projectImport.id
  )

  if (itemIndex === -1) {
    // Insert at the beginning (newest first)
    return dotProp.set(state, 'items', [projectImport, ...state.items])
  }

  return dotProp.set(state, `items.${itemIndex}`, projectImport)
}

export default (state = initialState, action) => {
  const error = action.error ? (action.error.data || action.error.message) : null
  let newState

  switch (action.type) {
    case actionCableConstants.DATA_RECEIVED_FROM_CHANNEL:
      if (action.channelName === 'ProjectImportsChannel') {
        return insertOrUpdate(state, action.data)
      }
      return state

    case projectImportsConstants.FETCH_ALL_REQUEST:
      newState = dotProp.set(state, 'fetchingAllError', null)
      return dotProp.set(newState, 'fetchingAllStatus', 'fetching')
    case projectImportsConstants.FETCH_ALL_FAILURE:
      newState = dotProp.set(state, 'fetchingAllError', error)
      return dotProp.set(newState, 'fetchingAllStatus', 'failed')
    case projectImportsConstants.FETCH_ALL_SUCCESS:
      newState = dotProp.set(state, 'fetchingAllError', null)
      newState = dotProp.set(newState, 'fetchingAllStatus', 'succeeded')
      newState = dotProp.set(newState, 'items', action.projectImports.data)

      newState = dotProp.set(
        newState,
        'itemsCount',
        action.projectImports.count
      )
      newState = dotProp.set(
        newState,
        'itemsCurrentPage',
        action.projectImports.current_page
      )
      return dotProp.set(
        newState,
        'itemsTotalPages',
        action.projectImports.total_pages
      )

    default:
      return state
  }
}
